import React from "react";
import { Chip, CircularProgress, Tooltip } from "@mui/material";
import { Row } from "../Common/Row";

/** A document's status on the Knowledge and project lists.
 *
 *  ready / failed are terminal color hints. `extracted` is ALSO terminal —
 *  text was extracted but the doc was not indexed (e.g. a chat attachment, or
 *  ingestion that didn't run). So are the image outcomes (spec 2026-10-25
 *  §5.8): a photo stored for picture search later, and an image with nothing
 *  to search. None of these may spin forever as "processing"; only genuine
 *  in-progress states (uploading / processing) get the spinner. */
export function DocumentStatusChip({ status }: { status: string }) {
  if (status === "ready") return <Chip size="small" color="success" label="ready" />;
  if (status === "failed") return <Chip size="small" color="error" label="failed" />;
  if (status === "extracted") return <Chip size="small" variant="outlined" label="not indexed" />;
  if (status === "pending_media")
    return (
      <Tooltip title="Stored. Photos become searchable when picture search is enabled.">
        <Chip size="small" variant="outlined" label="stored" />
      </Tooltip>
    );
  if (status === "skipped")
    return (
      <Tooltip title="This image has no text or diagram to add to the knowledge base.">
        <Chip size="small" variant="outlined" label="not added" />
      </Tooltip>
    );
  return (
    <Chip
      size="small"
      label={
        <Row align="center" gap={0.5}>
          <CircularProgress size={10} thickness={6} />
          processing
        </Row>
      }
    />
  );
}
